"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _hamburgerNavItem = _interopRequireDefault(require("./hamburger-nav-item"));
var _pushViewButton = _interopRequireDefault(require("./push-view-button"));
require("./hamburger-nav.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SecondaryHamburgerNavPanel = function SecondaryHamburgerNavPanel(_ref) {
  var closeHamburgerNav = _ref.closeHamburgerNav,
    navItems = _ref.navItems,
    pushViewItem = _ref.pushViewItem,
    pushViewButtonLabels = _ref.pushViewButtonLabels,
    setSecondaryPanelToOpen = _ref.setSecondaryPanelToOpen,
    signOutButton = _ref.signOutButton;
  return /*#__PURE__*/_react["default"].createElement("ul", null, /*#__PURE__*/_react["default"].createElement(_pushViewButton["default"], _extends({
    direction: "left",
    pushViewButtonLabels: pushViewButtonLabels
  }, pushViewItem, {
    onClick: function onClick() {
      setSecondaryPanelToOpen(null);
    }
  })), navItems && navItems.map(function (item, i) {
    return /*#__PURE__*/_react["default"].createElement(_hamburgerNavItem["default"], _extends({
      key: i
    }, item, {
      closeHamburgerNav: closeHamburgerNav
    }));
  }), signOutButton && /*#__PURE__*/_react["default"].createElement(_hamburgerNavItem["default"], _extends({
    addRule: true
  }, signOutButton, {
    closeHamburgerNav: closeHamburgerNav
  })));
};
SecondaryHamburgerNavPanel.propTypes = process.env.NODE_ENV !== "production" ? {
  navItems: _propTypes["default"].array,
  pushViewItem: _propTypes["default"].object,
  setSecondaryPanelToOpen: _propTypes["default"].func
} : {};
var _default = exports["default"] = SecondaryHamburgerNavPanel;